import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../../contexts/AuthContext';

// Le o retrato de status do backend enquanto `ativo`. O backend so pergunta ao
// DVR a cada 2 min; aqui basta reler a cada 30s (le memoria, nao o DVR).
const RELER_MS = 30000;

const VAZIO = { porCamera: new Map(), porGravador: new Map(), atualizadoEm: null };

export default function useStatusCameras(ativo) {
  const [status, setStatus] = useState(VAZIO);

  useEffect(() => {
    if (!ativo) return undefined;
    let cancelado = false;
    const ler = async () => {
      try {
        const res = await axios.get(`${API}/cameras/status`);
        const d = res.data?.data || {};
        if (cancelado) return;
        setStatus({
          porCamera: new Map((d.cameras || []).map((c) => [c.id, c])),
          porGravador: new Map((d.gravadores || []).map((g) => [g.id, g])),
          atualizadoEm: d.atualizado_em || null,
        });
      } catch {
        // Mantem o ultimo retrato; a tela segue funcionando sem cor.
      }
    };
    ler();
    const id = setInterval(ler, RELER_MS);
    return () => { cancelado = true; clearInterval(id); };
  }, [ativo]);

  return status;
}
